import * as React from 'react';

function Cricket(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.127 6.188l12.686 12.686a9.014 9.014 0 01-1.24.882L4.245 7.428c.255-.431.55-.847.882-1.24zm1.06-1.06a8.975 8.975 0 011.24-.882l12.328 12.328a9.063 9.063 0 01-.882 1.24L6.188 5.128zM8.866 3.56a9 9 0 019.499 2.075 9 9 0 012.074 9.5L8.865 3.56zM3.561 8.865L15.135 20.44a9 9 0 01-9.498-2.075 8.998 8.998 0 01-2.076-9.498z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Cricket;
